<template>
  <div class="order_wrap">
    <CommonHead title="我的预约"></CommonHead>
    <div class="ordertab">
      <van-tabs v-model="active" @click="onClick">
        <van-tab v-for="(item,index) in tabsList" :key="index" :name="index" :title="item"></van-tab>
      </van-tabs>
    </div>
    <van-pull-refresh class="content" v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="listLoad">
        <div class="ordergroup" v-for="(item,index) in list" :key="index" >
          <div class="order_status">
            <div class="vacc_name">
              <p class=""> {{ item.vaccineName }} </p>
              <van-tag color="#fff" text-color="#50A0FF" v-if="item.price">{{ item.price === '0' ? '免费' : `¥${item.price}` }}</van-tag>
            </div>
            <van-tag :color=" fifStatus(item.status) " :text-color="fifStatusText(item.status)">{{ item.status }}</van-tag>
          </div>
          <div class="order_cont">
            <div class="order_cell">
              <span class="cell_name">生产厂家</span><span> {{ item.manufacturer }} </span>
            </div>
            <div class="order_cell">
              <span class="cell_name">预约时间</span><span> {{ `${item.reservationDate} ${item.reservationTime}` }} </span>
            </div>
            <div class="order_cell">
              <span class="cell_name">受种者</span>
              <span> {{ item.profileName }} </span>
              <van-tag v-if="item.relation" class="celltag" plain color="#50A0FF" text-color="#50A0FF"> {{ item.relation }} </van-tag>
            </div>
          </div>
          <div class="order_foot">
            <template v-if="item.status === '待接种'">
              <van-button plain round size="small" type="default" color="#9a9a9a" @click="handleCancle(item)"> 取消预约 </van-button>
            </template>
            <template v-if="item.status == '已取消' || item.status == '已退款'">
              <van-button round size="small" color="#50A0FF" @click="enterHome(item)"> 重新预约 </van-button>
            </template>
            <template >
              <van-button round size="small" color="#50A0FF" @click="handleDetail(item)"> 查看详情 </van-button>
            </template>
<!--            <van-button plain round size="small" type="default" color="#9a9a9a" @click="handleReport(item, index)">-->
<!--              留观上报-->
<!--            </van-button>-->
<!--            <van-button class="order_btn" plain round size="small" type="default" color="#9a9a9a" @click="checkEvalute(item, index)">-->
<!--              查看评价-->
<!--            </van-button>-->
<!--            <van-button plain round size="small" type="default" color="#9a9a9a" @click="handleEvalute(item, index)">-->
<!--              立即评价-->
<!--            </van-button>-->
<!--            <van-button plain round size="small" type="default" color="#9a9a9a" @click="handlePay(item, index)">-->
<!--              立即支付-->
<!--            </van-button>-->

          </div>

        </div>
      </van-list>
      <van-empty description="暂无数据" v-if="list.length == 0" />
    </van-pull-refresh>
    <!-- 取消弹窗 -->
    <van-action-sheet v-model="show" title="取消预约提醒">
      <div class="cont">
        <div>根据门诊疫苗预约规定：</div>
        <ul>
          <li>第一次取消预约，用户当天不可进行再次预约；</li>
          <li>第二次取消预约，用户本周不可进行再次预约；</li>
          <li>第三次取消预约，用户本月不可进行再次预约。</li>
        </ul>
        <p>请确认，您是否继续取消本次疫苗预约？</p>
        <div class="btn">
          <van-button round @click="cancel">否</van-button>
          <van-button round type="info" @click="confirm(datas.detailId)">是</van-button>
        </div>
      </div>
    </van-action-sheet>

  </div>
</template>
<script>
import CommonHead from "components/CommonHead";
import {getAppReservation,cancleApplay} from '@/api/user'
import {  } from 'vuex'
import {Toast} from "vant";
export default {
  name: 'Order',
  components: {
    CommonHead
  },
  computed: {

  },
  data() {
    return {
      active: null,
      refreshing: true,
      finished: false,
      loading: false,
      list: [],
      queryParams: {
        current: 1,
        size: 10,
        payStatus: null,
        status: null,
      },
      // tabsList: [{ status: 1,title: '待接种'},{ status: 3,title: '退款/取消'},{ status: 2,title: '已完成'},{ status: '',title: '全部'}],
      tabsList: ['待接种','退款/取消','已完成','全部'],
      show: false,
      cancelId: '',
      datas: {} // 选中取消

    }
  },
  created() {
    this.active = parseInt(this.$route.query?.type || 0);
  },
  watch: {
    active() {
      this.queryParams.current = 1;
      switch (this.active) {
        case 0:
          this.queryParams.status = 1;
          break
        case 1:
          this.queryParams.status = 3;
          break
        case 2:
          this.queryParams.status = 2;
          break
        case 3:
          this.queryParams.status = null
      }
      this.checkAppReservationList()
    }
  },
  methods: {
    // 下拉刷新
    onRefresh() {
      try {
        this.queryParams.current = 1
        this.checkAppReservationList();
      } finally {
        if (this.refreshing) {
          this.refreshing = false
        }
      }
    },
    // 下拉刷新
    listLoad() {
      this.checkAppReservationList();
      this.queryParams.current++
    },
    checkAppReservationList () {
      let that = this;
      getAppReservation(this.queryParams,{}).then(res => {
        if (res.code == 0) {
          if (res.data.current == 1) {
            that.list = res.data.records;
          } else {
            that.list.push(...res.data.records)
          }
          that.loading = false;
          that.finished = res.data.records.length < that.queryParams.size;
        }
      }).catch(err => {
        that.list = [];
        that.loading = false;
        that.finished = false;
      })
    },
  //  取消
    handleCancle(item) {
      // this.handleCancle = item;
      this.cancelId = item.detailId;
      this.show = true;
    },
    handleDetail(item) {
      this.$router.push({ path: '/order-detail', query: { id: item.detailId,status: item.status }})
    },
    onClick(name, title) {
      this.queryParams.current = 1
      this.active = name;
    },
    fifStatus(status) {
      if (status == '已完成') {
        return '#ECFAF5'
      } else if (status == '待评价') {
        return '#FFF2E9'
      } else if (status == '待支付') {
        return '#FFF2EE'
      } else if (status = '已取消') {
        return '#F0F0F0'
      } else if (status = '已退款') {
        return '#FEFFFF'
      } else {
        return '#E5F1FF'
      }
    },
    fifStatusText(status) {
      if (status == '已完成') {
        return '#0BC183'
      } else if (status == '待评价') {
        return '#FF8731'
      } else if (status == '待支付') {
        return '#FF6238'
      } else if (status = '已取消') {
        return '#666666'
      } else if (status = '已退款') {
        return '#ED6071'
      } else {
        return '#50A0FF'
      }
    },
  //  重新预约
    enterHome() {
      this.$router.push('/home')
    },
    cancel() {
      this.show = false;
    },
    confirm() {
      let that = this;
      cancleApplay({id: that.cancelId}).then(res => {
        if (res.code == 0) {
          Toast('取消成功');
          this.show = false
          setTimeout(() => {
            that.queryParams.current = 1;
            that.checkAppReservationList();
          })
        } else {
          Toast('取消失败');
          this.show = false
          setTimeout(() => {
            that.queryParams.current = 1;
            that.checkAppReservationList();
          })
        }
      })
    }

  }
}
</script>
<style lang="less" scoped >
.order_wrap {
  width: 100%;
  box-sizing: border-box;
  .ordertab {
    padding: 0 14px;
    width: 100%;
    box-sizing: border-box;
    background: #F6F8FA;
    position: sticky;
    left: 0;
    top: 97px;
    z-index: 10;

  }

  .content {
    padding: 12px 14px;
    .ordergroup {
      width: 100%;
      box-sizing: border-box;
      background: #FFFFFF;
      margin-bottom: 15px;
      border-radius: 10px;
      padding: 13px;

      .order_status {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-bottom: 10px;

        .status_txt {
          width: 50px;
          text-align: right;
          font-size: 14px;
          color: #4689FF;
        }
        .vacc_name {
          width: calc(100% - 50px);
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          p {
            max-width: calc(100% - 40px);
            box-sizing: border-box;
            font-size: 15px;
            color: #333333;
            font-weight: bold;
            padding-left: 5px;
          }

        }

      }
      .order_cont {
        padding-bottom: 10px;

        .order_cell {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 4px;
          line-height: 30px;
          color: #666666;

          .cell_name {
            display: inline-block;
            width: 70px;
            box-sizing: border-box;
          }
          .celltag {
            margin-left: 5px;
          }
        }

      }
      .order_foot {
        width: 100%;
        box-sizing: border-box;
        padding-top: 15px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        border-top: 1px solid #F3F3F3;

        .van-button {
          margin-left: 5px;
        }


      }






    }


  }
  .cont {
    padding: 13px;
    color: var(--grey);
    line-height: 22px;
    ul {
      margin-bottom: 30px;
    }
    .btn {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      .van-button {
        width: 49%;
      }
    }
  }



}


</style>